import { render, staticRenderFns } from "./manage-alert-organization.vue?vue&type=template&id=2cbe00d8&scoped=true"
import script from "./manage-alert-organization.vue?vue&type=script&lang=js"
export * from "./manage-alert-organization.vue?vue&type=script&lang=js"
import style0 from "./manage-alert-organization.vue?vue&type=style&index=0&id=2cbe00d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbe00d8",
  null
  
)

export default component.exports